import { useMemo } from 'react'
import {
  CssBaseline,
  useMediaQuery,
  PaletteMode,
  ThemeProvider,
  createTheme
} from '@mui/material'
import { getTheme } from '../../theme'
import { AppThemeProps } from './AppTheme.types'

const AppTheme = ({
  customTheme = {},
  mode,
  system = false,
  children
}: AppThemeProps) => {
  const systemMode: PaletteMode = useMediaQuery('(prefers-color-scheme: dark)')
    ? 'dark'
    : 'light'
  const activeMode: PaletteMode =
    (system && systemMode) || mode || customTheme?.palette?.mode || 'light'

  const theme = useMemo(() => {
    return createTheme(getTheme(activeMode, customTheme))
  }, [activeMode, customTheme])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export default AppTheme
